import React, { useEffect, useState, Fragment } from 'react';
import '../scss/components/section.scss';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Header from '.././components/header/header.jsx';
import PageTitle from '../components/page-title/page-title-v1';
import Flathelp from '../components/flat-help';
import Footer from '../components/footer/footer-v1';
import dataFooter from '../assets/fake-data/data-footer';
import Bottom from '../components/bottom';
import Liveaution from '../components/liveauctions/liveauction-v3';
import dataLiveaution2 from '../assets/fake-data/data-liveaution';

import CardModal from '../components/CardModal';

import img1 from '../assets/images/avatar/avt-01.png'
import img2 from '../assets/images/avatar/avt-04.jpg'
import img3 from '../assets/images/avatar/avt-05.jpg'

function LiveAuctionDetails(props) {
    const [dataLiveaution] = useState(
        [
            {
                img: img1,
                author: "Themesflat",
                price1: "2.39 ETH",
                price2: "=€ 10.23",
            },
            {
                img: img2,
                author: "Themesflat",
                price1: "2.39 ETH",
                price2: "=€ 10.23",
            },
            {
                img: img3,
                author: "Themesflat",
                price1: "2.39 ETH",
                price2: "=€ 10.23",
            },
        ]
    )
    const [modalShow, setModalShow] = useState(false);
    const [countdownDate] = useState(new Date('7/30/2022').getTime());
    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        setInterval(() => setNewTime(), 1000);
    },);

    const setNewTime = () => {
        if (countdownDate) {
            const currentTime = new Date().getTime();

            const distanceToDate = countdownDate - currentTime;

            let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
            let hours = Math.floor(
                (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            );
            let minutes = Math.floor(
                (distanceToDate % (1000 * 60 * 60)) / (1000 * 60),
            );
            let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

            const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

            days = `${days}`;
            if (numbersToAddZeroTo.includes(hours)) {
                hours = `0${hours}`;
            } else if (numbersToAddZeroTo.includes(minutes)) {
                minutes = `0${minutes}`;
            } else if (numbersToAddZeroTo.includes(seconds)) {
                seconds = `0${seconds}`;
            }

            setState({ days: days, hours: hours, minutes, seconds });
        }
    };


    return (
        <Fragment>
            <div className="tf-section flat-auctions-details">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className='wrap-img'>
                                <div className="img-detail" style={{ marginBottom: "0.8em" }}>
                                    <div className="media">
                                        <img src={require('../assets/images/box-item/service-1.jpg')} alt="Nufti" />
                                    </div>
                                </div>
                                <div className="img-detail" style={{ marginBottom: "0.8em" }}>
                                    <div className="media">
                                        <img src={require('../assets/images/box-item/service-2.jpg')} alt="Nufti" />
                                    </div>
                                </div>
                                <div className="img-detail" style={{ marginBottom: "0.8em" }}>
                                    <div className="media">
                                        <img src={require('../assets/images/box-item/service-3.jpg')} alt="Nufti" />
                                    </div>
                                </div>
                                <div className="img-detail">
                                    <div className="media">
                                        <img src={require('../assets/images/box-item/service-4.jpg')} alt="Nufti" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="post mtop-7">
                                <p><br /></p>
                                <h2 className="fw-5 mt-2">How to transform your Public Relations?</h2>


                                <p className="texts">NextGenPR is a pioneering Public Relations (PR) software company focused on developing cutting-edge digital twin technology to transform audience engagement and communication strategies. By leveraging advanced virtual audience models and integrating with existing generative AI solutions like ChatGPT, NextGenPR offers PR professionals powerful tools to enhance their outreach, personalize messaging, and navigate crises effectively.
                                </p>
                                <div className="information flex">
                                    <p>
                                    </p>

                                </div>


                                <Tabs>
                                    <TabList className="menu-tab tab-title">
                                        <Tab selectedClassName="selected-tab"><h3>NextInsight</h3></Tab>
                                        <Tab selectedClassName="selected-tab"><h3>NextData</h3></Tab>
                                        <Tab selectedClassName="selected-tab"><h3>NextContent</h3></Tab>
                                        <Tab selectedClassName="selected-tab"><h3>NextCrisis</h3></Tab>
                                    </TabList>
                                    <TabPanel>
                                        <div className="content-tab">
                                            <div className="provenance">
                                                <p>NextInsight provides PR professionals with continuously updated, real-time insights into audience behavior and preferences. This service enables timely and accurate decision-making, allowing for the optimization of PR strategies based on the most current data available.
                                                    <br />  NextInsight leverages advanced digital twin technology to create dynamic audience models. These models are continuously updated through the integration of data from various sources, including CRM systems, social media platforms, and marketing databases. The service includes an analytics dashboard that provides visualizations and reports on audience trends, behaviors, and preferences.

                                                </p>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className="content-tab">
                                            <div className="provenance">
                                                <p>NextData ensures a holistic view of the audience by aggregating data from multiple sources. This service enables more effective PR planning and execution based on a complete and accurate understanding of the target audience.
                                                    <br /> NextData integrates data from CRM systems, social media platforms, marketing databases, and other relevant sources. The service uses ETL (Extract, Transform, Load) processes to cleanse and standardize data, ensuring high-quality and consistent inputs for digital twin models. It includes data connectors and APIs for easy integration with various data sources.
                                                </p>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className="content-tab">
                                            <div className="provenance">
                                                <p>NextContent automates the creation of highly personalized content, ensuring that each communication is relevant and engaging for the audience. This service allows PR teams to deliver tailored messages across email, SMS, and other channels at scale, enhancing audience engagement and effectiveness of PR campaigns.
                                                    <br /> NextContent integrates with existing generative AI solutions like ChatGPT to generate customized content. The service uses the dynamic audience models from InsightNext to tailor content based on individual and segment characteristics. It includes APIs for seamless integration with email marketing platforms, SMS services, and other communication tools.
                                                </p>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <div className="content-tab">
                                            <div className="provenance">
                                                <p>NextCrisis equips PR teams with tools for early detection and management of potential crises. By providing timely alerts and strategic suggestions, this service helps mitigate issues before they escalate, protecting the organization's reputation and maintaining public trust.
                                                    <br />NextCrisis utilizes real-time monitoring of audience sentiment and behavior patterns through digital twins. The service employs machine learning algorithms to detect anomalies and potential crises early. It offers an alert system that notifies PR teams of emerging issues and provides actionable recommendations for crisis management.
                                                </p>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </Tabs>
                            </div>
                            <div className="button-place-bid">
                                <Link to="/business-type" data-toggle="modal" data-target="#popup_bid" className="sc-button btn-3" ><span>ُTry It</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CardModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </Fragment>
    );
}

export default LiveAuctionDetails;